<template>
  
  <div :class='screenwidth>1500?"dw2":"dw1" '> 
   <div class="dwstr"> 客服微信 </div>
    <img  :class=" screenwidth>1500? 'dwimg2':'dwimg'"  :src= "img1"  />
  </div>
 
 
</template>

<script>
 
export default {
  data() {
    return {
        img1:require("@/assets/images/kfwx.jpg"),
 
        screenwidth:document.documentElement.clientWidth,
        dwleft:document.documentElement.clientWidth/2-300
  }
},
methods:{
    tologin(){
      location.href="https://www.maxrong.com/#/login";

    }

   }
  }
</script>

<style scoped>
.dw1 {
  position: fixed ;
  right: 5px;
  top: 320px;
  width: 80px;
  height: 100px;
}
.dw2 {
  position: fixed ;
  right: 5px;
  top: 320px;
  width: 180px;
  height: 200px;
}

.dwimg{
  width: 80px;
  height: 80px;
}
.dwimg2{
  width: 180px;
  height: 180px;
}
.dwstr{
  color:rgb(47, 146, 245);
  text-align:center;
 
}
</style>


// WEBPACK FOOTER //
// src/new/lxkf.vue